<div
  class="sidebar rounded-2xl py-4 bg-surface-50 dark:bg-surface-900 h-full flex flex-col justify-between transition-[width] duration-300 ease-in-out overflow-hidden"
  [ngClass]="isExpanded() ? 'w-56 px-3 items-start' : 'w-16 px-2 items-center'"
>
  <!-- Top: Logo + Main Nav Items -->
  <div class="w-full">

    <!-- Logo -->
    <div class="flex items-center mb-10" [ngClass]="isExpanded() ? 'px-1' : 'justify-center'">
      <div class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0">
        <img src="assets/logo/logo.svg" alt="Logo" class="w-8 h-8"/>
      </div>
      <span *ngIf="isExpanded()" class="font-semibold text-sm flex-1 truncate mx-2">KeyConnect</span>
    </div>

    <!-- Main Navigation Items -->
    <div class="flex flex-col gap-1 w-full">
      <div
        *ngFor="let navItem of navigationItems"
        (click)="selectNavItem(navItem)"
        [pTooltip]="isExpanded() ? '' : navItem.title"
        tooltipPosition="right"
        class="flex items-center gap-3 cursor-pointer text-base rounded-lg transition-all select-none py-3"
        [ngClass]="{
          'text-muted-color hover:bg-emphasis': !selectedNavItem || selectedNavItem.title !== navItem.title,
          'text-primary-contrast sidebar-primary-background': selectedNavItem && selectedNavItem.title === navItem.title,
          'px-3 w-full': isExpanded(),
          'justify-center w-12': !isExpanded()
        }"
      >
        <i [class]="navItem.icon"></i>
        <span *ngIf="isExpanded()" class="text-sm font-medium truncate">{{ navItem.title }}</span>
      </div>
    </div>
  </div>

  <!-- Bottom: Profile, Settings, Logout + Toggle -->
  <div class="w-full">

    <!-- Additional Navigation Items -->
    <div class="flex flex-col gap-1 w-full mb-3">
      <ng-container *ngFor="let navItem of filteredAdditionalNavItems">

        <!-- Profile row: avatar + name/email -->
        <div
          *ngIf="navItem.title === 'Profilo'; else standardNavItem"
          (click)="selectAdditionalNavItem(navItem)"
          [pTooltip]="isExpanded() ? '' : navItem.title"
          tooltipPosition="right"
          class="flex items-center gap-3 cursor-pointer rounded-lg transition-all select-none py-2"
          [ngClass]="isExpanded() ? 'px-2 w-full' : 'justify-center w-12'"
        >
          <p-avatar [image]="userProfile.imageMediaUrl" size="normal" shape="circle" class="shrink-0"/>
          <div *ngIf="isExpanded()" class="overflow-hidden flex-1 min-w-0">
            <p class="text-sm font-medium truncate m-0">{{ userProfile.name }}</p>
            <p class="text-xs text-muted-color truncate m-0">{{ userProfile.email }}</p>
          </div>
        </div>

        <!-- Standard rows: Settings, Logout -->
        <ng-template #standardNavItem>
          <div
            (click)="selectAdditionalNavItem(navItem)"
            [pTooltip]="isExpanded() ? '' : navItem.title"
            tooltipPosition="right"
            class="flex items-center gap-3 cursor-pointer text-base rounded-lg transition-all select-none py-3"
            [ngClass]="{
              'text-muted-color hover:bg-emphasis': !selectedNavItem || selectedNavItem.title !== navItem.title,
              'text-primary-contrast sidebar-primary-background': selectedNavItem && selectedNavItem.title === navItem.title,
              'px-3 w-full': isExpanded(),
              'justify-center w-12': !isExpanded()
            }"
          >
            <i [class]="navItem.icon"></i>
            <span *ngIf="isExpanded()" class="text-sm font-medium truncate">{{ navItem.title }}</span>
          </div>
        </ng-template>

      </ng-container>
    </div>

    <!-- Divider -->
    <p-divider class="my-2"></p-divider>

    <!-- Toggle Button -->
    <div
      (click)="toggleSidebar()"
      class="flex items-center gap-3 cursor-pointer text-muted-color hover:bg-emphasis rounded-lg transition-all select-none py-3 mt-1"
      [ngClass]="isExpanded() ? 'px-3 w-full' : 'justify-center w-12'"
    >
      <i [class]="isExpanded() ? 'fa-light fa-sidebar-flip' : 'fa-light fa-sidebar'"></i>
      <span *ngIf="isExpanded()" class="text-sm font-medium">Collapse</span>
    </div>
  </div>
</div>
